import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  FORCE_DELETE_SKILL_ASSESSMENTS
} from "@routes";

const apiConfig = [
  {
    name: "forceDeleteAssessmentTracking",
    method: "delete",
    url: FORCE_DELETE_SKILL_ASSESSMENTS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    assessmentStatusData: [],
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "assessmentStatus",
  apiConfig,
  customReducers
);

const assessmentStatusSlice = slice;
export default assessmentStatusSlice.reducer;

export const {
  forceDeleteAssessmentTracking
} = thunks;

export const {rowSelect
} = actions;